export enum OutputMode {
  full = 'full',
  yearMonth = 'yearmonth',
  date = 'date',
  moment = 'moment',
}

export enum YearOrdering {
  ascending = 'asc',
  descending = 'desc',
}
